import CDN from "../CDN";
import type AudioManager from "./AudioManager";

export const ERROR_SOUND = CDN("/sounds/error-call-to-attention.mp3");
export const NOTIFICATION_SOUND = CDN("/sounds/notification-sound.mp3");
export const KITCHEN_ORDER_SOUND = CDN("/sounds/hotel-bell.mp3");

const SHOPFRONT_SOUNDS = [
    ERROR_SOUND,
    NOTIFICATION_SOUND,
    KITCHEN_ORDER_SOUND,
];

/**
 * Loads all the shopfront sounds into local cache
 * @param audioManager
 */
export async function preloadShopfrontAudio(audioManager: AudioManager): Promise<void> {
    for(const sound of SHOPFRONT_SOUNDS) {
        await audioManager.loadSound(sound, undefined, true);
    }
}
